(function wait17track() {
  const params = new URLSearchParams(window.location.search);
  const rawOrderNumber = params.get("orderNumber");
  const orderNumber = rawOrderNumber
    ? rawOrderNumber.startsWith("#")
      ? rawOrderNumber
      : `#${rawOrderNumber}`
    : rawOrderNumber;
  const email = params.get("email");
  if (!orderNumber && !email) return;

  const maxObserveDurationMs = 10000;
  let disconnectTimer = null;
  let observer = null;

  const disconnectObserver = () => {
    observer?.disconnect();
    if (disconnectTimer) window.clearTimeout(disconnectTimer);
  };

  const setNativeInputValue = (input, value) => {
    const descriptor = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value",
    );
    descriptor?.set?.call(input, value);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  };

  const tryFillFields = () => {
    const host = document.querySelector(".yq-app");
    if (!host) return false;

    const orderNumberInput = host.querySelector("#orderForm_order_no");
    const emailInput = host.querySelector("#orderForm_user_email");

    let hasUpdated = false;

    if (orderNumber && orderNumberInput) {
      if (orderNumberInput.value !== orderNumber) {
        setNativeInputValue(orderNumberInput, orderNumber);
      }
      hasUpdated = true;
    }

    if (email && emailInput) {
      if (emailInput.value !== email) {
        setNativeInputValue(emailInput, email);
      }
      hasUpdated = true;
    }

    const orderNumberReady = !orderNumber || Boolean(orderNumberInput);
    const emailReady = !email || Boolean(emailInput);

    return hasUpdated && orderNumberReady && emailReady;
  };

  if (tryFillFields()) return;

  observer = new MutationObserver(() => {
    if (!tryFillFields()) return;
    disconnectObserver();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  disconnectTimer = window.setTimeout(disconnectObserver, maxObserveDurationMs);
})();